export const main = {
  100: "#AE2012",
  200: "#002C3D",
  300: "#8ECAE6",
  400: "#FB8500",
  500: "#FFB703",
  600: "#FFFFFF",
};

export const neutral = {
  100: "#ffffff",
  200: "#f4f5f7",
  300: "#e1e1e1",
  400: "#737581",
  500: "#4a4b53",
  600: "#000000",
};
export const text = {
  text: "#333",
  textInverted: "#fff",
};
